<script setup lang="ts">
import { computed } from 'vue';
import { useInstitutionStore } from '~/entities/institution/@x/product'
import type { ProductTag } from '~/utils/types/ProductTag';

const props = defineProps<{
  tag?: number | string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string | null;
}>();

const institutionStore = useInstitutionStore();

// Получаем тег из store
const productTag = computed<ProductTag | undefined>(() => {
  const tagId = typeof props.tag === 'number' ? props.tag : null;
  if (tagId === null) return undefined;
  return institutionStore.getTagById(tagId);
});

const badgeSize = computed(() => props.size || 'sm');

// Функция для получения цвета тега с fallback
const getTagColor = (tag: ProductTag): string => {
  return tag.color || '#757575';
};

// Функция для получения контрастного цвета текста
const getTextColor = (backgroundColor: string): string => {
  const hex = backgroundColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? '#000000' : '#FFFFFF';
};

// Преобразуем название иконки из БД в формат Iconify
const getIconName = (iconName: string | null): string | undefined => {
  if (!iconName) return undefined;
  if (iconName.startsWith('i-')) return iconName;
  return `i-heroicons-${iconName}`;
};

// Custom UI конфигурация
const customUI = computed(() => ({
  base: 'inline-flex items-center font-semibold transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md',
  rounded: 'rounded-md',
  variant: {
    solid: 'shadow-sm',
  },
}));
</script>

<template>
  <div v-if="productTag" :class="className">
    <UBadge
      :label="productTag.label"
      :icon="getIconName(productTag.icon)"
      :size="badgeSize"
      variant="solid"
      :ui="customUI"
      :style="{
        backgroundColor: getTagColor(productTag),
        color: getTextColor(getTagColor(productTag)),
      }"
      class="badge-custom"
    />
  </div>
</template>

<style scoped>
.badge-custom {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.badge-custom:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.15), 0 2px 4px -1px rgba(0, 0, 0, 0.1);
}
</style>



